import { eMatchedQueryValue } from '../../../../types/accounting/eMatchedQueryValue';

export const getMismatchMessage = (orderCreatedStr: string, matchedValue: eMatchedQueryValue) => {
  let message = '';
  if (matchedValue === eMatchedQueryValue.MISMATCHED) {
    message += 'Bank Account Does Not Match - Escrow Balances Unaffected';
  }
  return message;
};
